import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { normalizeDeviceRouteChildren } from '@/utils/menuNormalize'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/portal/index.vue'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export function addDynamicRoutes(routes) {
  routes.forEach(route => {
    router.addRoute(route)
  })
}

/** 加载后台菜单路由（登录后进入概览前必须执行） */
export async function ensureDynamicRoutes() {
  if (store.state.routes.length > 0) return true
  const request = (await import('@/utils/request')).default
  const res = await request.get('/system/getRouters')
  const dynamicRoutes = (res.data || []).map(r => ({
    path: r.path,
    component: () => import('@/layout/index.vue'),
    meta: r.meta,
    children: normalizeDeviceRouteChildren(r.children).map(c => ({
      path: c.path,
      name: c.name || c.path,
      component: loadView(c.component),
      meta: c.meta
    }))
  }))
  store.commit('SET_ROUTES', dynamicRoutes)
  dynamicRoutes.forEach(route => router.addRoute(route))
  return true
}

/** 登录后进入后台首页（不经过门户） */
export async function goAdminHome() {
  await ensureDynamicRoutes()
  return router.replace('/home/overview')
}

router.beforeEach(async (to, from, next) => {
  const token = store.state.token

  if (to.path === '/login') {
    if (token) {
      try {
        await ensureDynamicRoutes()
        next({ path: '/home/overview', replace: true })
      } catch (e) {
        store.commit('CLEAR_AUTH')
        next()
      }
      return
    }
    next()
    return
  }

  if (to.path === '/') {
    next()
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (store.state.routes.length === 0) {
    try {
      await ensureDynamicRoutes()
      next({ ...to, replace: true })
    } catch (e) {
      store.commit('CLEAR_AUTH')
      next('/login')
    }
    return
  }

  next()
})

function loadView(view) {
  return () => import(`@/views/${view}.vue`)
}

export default router
